import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import PopupCalendar from '../popup-calendar';
import { REDUCER_NAME } from '../../reducer';

class Filter extends React.Component {
  render() {
    return (
      <div
        className="d-flex"
        style={{
          position: 'relative',
        }}
      >
        <div className="d-flex">
          <PopupCalendar {...this.props} isDateSelected={null} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  currentTab: state[REDUCER_NAME].currentTab,
  currentChildTab: state[REDUCER_NAME].currentChildTab,
});

export default connect(
  mapStateToProps,
  null,
)(Filter);
